<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-31 02:03:27
-->
<template>
  <div class="bidItem">
    <div class="inner">
      <div class="top flex">
        <div class="left">
          {{ info.bizName.split("")[0] }}
        </div>
        <div class="right">
          <div class="bizName">{{ `${info.bizName || "--"}` }}</div>
          <div class="sgInfo">
            <span class="goodstype">{{ info.shipName || "--" }}</span>
            <span style="color: #2096ff">mmsi:{{ info.mmsi }}</span>
          </div>
        </div>
      </div>
      <div class="info">
        <p><span>提交时间：</span>{{ info.submitTime || "--" }}</p>
        <p v-if="type != 'workList1'">
          <span>审核时间：</span>{{ info.checkTime || "--" }}
        </p>
        <p><span>安装人员：</span>{{ info.installPerson || "--" }}</p>
        <p><span>提单人员：</span>{{ info.submitPerson || "--" }}</p>
        <div v-if="type == 'workList1'" class="btn1" @click="changeStatus">
          审核
        </div>
        <div v-if="info.state == 2" class="btn2">已驳回</div>
        <div v-if="info.state == 4" class="btn3">已通过</div>
        <div v-if="info.state == 5" class="btn4">不通过</div>
      </div>
      <div v-if="type == 'workList2'">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            title="驳回理由"
            title-class="titco1"
            label-class="lasty"
            :name="info.id"
            >{{ info.rejectReason }}</van-collapse-item
          >
        </van-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bidItem",
  components: {},
  props: {
    type: String,
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      activeNames: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    changeStatus() {
      this.$emit("action", this.info);
    },
  },
};
</script>

<style lang="less" scoped>
.bidItem {
  width: 96%;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 10px;
  padding: 0 15px;
  .inner {
    padding: 15px 0;
    /deep/.titco1 {
      font-size: 14px;
      font-weight: 500;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      color: #666666;
    }
    /deep/.van-collapse-item__content {
      font-size: 12px;
      font-weight: normal;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      color: #999999;
    }
    /deep/.van-cell {
      padding: 10px 16px 10px 0;
    }
    .top {
      margin-bottom: 13px;
      .left {
        flex: 0 0 40px;
        height: 40px;
        font-size: 20px;
        line-height: 40px;
        text-align: center;
        background: #44b1f9;
        border-radius: 6px;
        color: #fff;
        margin-right: 10px;
      }
      .bizName {
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
        font-weight: 500;
        color: #333333;
        padding: 2px 0;
        line-height: 16px;
        margin-bottom: 2px;
      }
      .sgInfo {
        span {
          display: inline-block;
          padding: 2px 5px;
          font-size: 12px;
          line-height: 1.1;
        }
        .goodstype {
          margin-right: 2px;
          background: rgba(31, 181, 74, 0.15);
          color: #1fb54a;
        }
        .goodsWeight {
          margin-right: 10px;
          background: rgba(255, 0, 0, 0.15);
          color: #ff0000;
        }
      }
    }
    .middle {
      display: inline-block;
      vertical-align: middle;
      height: 28px;
      background: rgba(68, 177, 249, 0.06);
      border-radius: 5px;
      line-height: 28px;
      padding: 0 15px;
      color: #333;
      margin-bottom: 15px;
      span,
      img {
        display: inline-block;
        vertical-align: middle;
        font-size: 13px;
      }
      img {
        width: 23px;
        margin: 0 15px;
      }
      .orgin {
        width: 16px;
        height: 16px;
        text-align: center;
        font-size: 12px;
        line-height: 16px;
        background-color: rgba(255, 0, 0, 0.24);
        border-radius: 2px;
        color: #ff0101;
        margin-right: 5px;
      }
      .des {
        width: 16px;
        height: 16px;
        text-align: center;
        font-size: 12px;
        line-height: 16px;
        background-color: rgba(100, 198, 123, 0.24);
        border-radius: 2px;
        color: #64c67b;
        margin-right: 5px;
      }
      .tip {
        color: #999;
        margin-right: 5px;
      }
    }
    .info {
      border-top: 1px solid #eeeeee;
      padding-top: 10px;
      p {
        font-size: 13px;
        line-height: 2;
        color: #333;
        span {
          color: #999;
          display: inline-block;
          margin-right: 5px;
        }
      }
      .btn1 {
        text-align: center;
        width: 66px;
        height: 26px;
        background: #44b1f9;
        font-size: 14px;
        line-height: 26px;
        color: white;
        border-radius: 5px;
        float: right;
        margin-top: -35px;
      }
      .btn2 {
        text-align: center;
        width: 66px;
        height: 26px;
        background: rgba(68, 177, 249, 0.15);
        border: 1px solid #44b1f9;
        font-size: 14px;
        line-height: 26px;
        color: #44b1f9;
        border-radius: 5px;
        float: right;
        margin-top: -35px;
      }
      .btn4 {
        text-align: center;
        width: 66px;
        height: 26px;
        background: #c1c1c1;
        border-radius: 5px;
        font-size: 14px;
        line-height: 26px;
        color: white;
        float: right;
        margin-top: -35px;
      }
      .btn3 {
        text-align: center;
        width: 66px;
        height: 26px;
        background: #08b80c;
        border-radius: 5px;
        font-size: 14px;
        line-height: 26px;
        color: white;
        float: right;
        margin-top: -35px;
      }
    }
  }
}
</style>